import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles({
  authorizeTitle: {
    textAlign: 'center',
    paddingBottom: '3.91vh',
  },
  swipeAuthorizeTitlePad: {
    paddingTop: '6.51vh',
  },
  barError: {
    backgroundColor: themeColor.alert,
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '2vw',
    width: '100%',
    paddingBottom: '5vh',
  },
  bar: {
    width: '4.4vw',
    height: '1.31vh',
    margin: 'auto',
  },
  barPadding: {
    paddingBottom: '5.86vh',
  },
  barPaddingOpenPrice: {
    paddingBottom: '3.91vh',
  },
  authorizeIdText: {
    color: themeColor.palesky,
    textAlign: 'center',
    padding: '0 .88vw 0 .88vw',
  },
  openPriceText: {
    color: themeColor.palesky,
    textAlign: 'center',
    padding: '0 5.565vw 10.156vh 3.5637vw',
  },
  swipeCardText: {
    color: themeColor.palesky,
    textAlign: 'center',
    padding: '0 8.42vw 0 8.42vw',
  },
  iconContainer: {
    padding: '1.96vh 0 5.86vh 0',
    justifyContent: 'center',
  },
  swipeIconContainer: {
    padding: '1.96vh 0 6.38vh 0',
    justifyContent: 'center',
  },
  authorizeOnlineItemIdCancelButton: {
    alignSelf: 'flex-start',
    paddingLeft: '.464vw',
  },
  cancelButton: {
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    border: `1px solid ${themeColor.secondaryLight}`,
    '& .label': {
      fontSize: vh(2.08),
      letterSpacing: '1.25px',
      color: themeColor.defaultTextColor,
    },
  },
  itemName: {
    paddingLeft: '3.49vw',
  },
  openPriceItemName: {
    paddingLeft: '4.662vw',
  },
  itemUnit: {
    color: themeColor.buttonIconGrey,
    paddingLeft: '.26vw',
    alignSelf: 'flex-end',
  },
  itemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  swipeItemContainerPad: {
    padding: '0 8.06vw 0 8.06vw',
  },
  openPriceContainerPad: {
    paddingLeft: '4.22vw',
  },
  priceContainer: {
    display: 'flex',
    paddingRight: '5.49vw',
  },
  itemId: {
    color: themeColor.palesky,
    paddingLeft: '3.49vw',
  },

  imageContainer: {
    height: '3.13vh',
    width: '1.76vw',
    display: 'flex',
    flexDirection: 'column',
  },
  swipeItemId: {
    color: themeColor.palesky,
    alignSelf: 'start',
  },
  swipePriceContainer: {
    display: 'flex',
  },
  darkText: {
    color: themeColor.tangaroa,
  },
});
